var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.667,
    height: 20,
    viewBox: "888 354 26.667 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M914.161 360.604a.314.314 0 0 1 .506.245V371.5a2.5 2.5 0 0 1-2.5 2.5H890.5a2.5 2.5 0 0 1-2.5-2.5v-10.646c0-.26.297-.406.505-.245 1.167.907 2.714 2.058 8.026 5.917 1.1.802 2.953 2.49 4.802 2.48 1.86.015 3.75-1.71 4.808-2.48 5.312-3.86 6.854-5.016 8.02-5.922Zm-12.828 6.73c1.209.02 2.948-1.522 3.823-2.157 6.912-5.016 7.438-5.453 9.031-6.703.303-.234.48-.599.48-.984v-.99a2.5 2.5 0 0 0-2.5-2.5H890.5a2.5 2.5 0 0 0-2.5 2.5v.99c0 .385.177.744.48.984 1.593 1.245 2.119 1.687 9.03 6.703.875.635 2.615 2.177 3.823 2.156Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Icon awesome-envelope"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/EmailIcon.ec1d6b07aecf2b9c741761682aba21a9.svg";
export { ForwardRef as ReactComponent };